import Vue from 'vue';
import visibility from 'vue-visibility-change';

Vue.use(visibility);
